module.exports = __webpack_public_path__ + "img/pantallazo-genetic-profile.a241cb2e.jpg";